import { AfterViewInit, Component, HostListener, OnInit, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router, RoutesRecognized } from '@angular/router';
import {
    AgentLogoutDataRemoved, AppDataService, ConfirmDialogModel, ConfirmDialogPopupComponent, CrudService, DEFAULT_COMMON_DASHBOARD_NAVIGATION, IApplicationResponse,
    LoggedInUserModel, ModulesBasedApiSuffix, PageBasedPermissionsRemoved,
    ResponseMessageTypes,
    SharedModuleApiSuffixModels, SidebarDataRemoved, SignalRTriggers, SnackbarService, UserService,
    agentEncryptedPassword$,
    agentLoginDataSelector,
    retrieveAlreadyLoggedInAgentDetails
} from '@app/shared';
import { OtherService, RxjsService, AgentLoginService } from '@app/shared/services';
import { HubConnection } from '@microsoft/signalr';
import { EventMgntModuleApiSuffixModels } from '@modules/event-management';
import { DynamicEagerLoadingCreate, DynamicEagerLoadingRemove, Logout, StaticEagerLoadingRemove, isLoggedIn, loggedInUserData } from '@modules/others';
import { LeadCreationStepperParamsRemoveAction, LeadCreationUserDataRemoveAction, LeadHeaderDataRemoveAction, SalesModuleApiSuffixModels, ScheduleCallbackViewModalComponent } from '@modules/sales';
import { RebookSnoozeModalComponent } from '@modules/technical-management/components/rebook-snooze';
import { TechnitianInspectionSnoozeModalComponent } from '@modules/technical-management/components/technitian-inspection-snooze/technitian-inspection-snooze-modal.component';
import { TechnicalMgntModuleApiSuffixModels } from '@modules/technical-management/shared';
import { Store, select } from '@ngrx/store';
import { MessageService } from 'primeng/api';
import { Observable, combineLatest } from 'rxjs';
import { filter, map, pairwise } from 'rxjs/operators';
import { AppState } from './reducers';
import { SignalrConnectionService } from './shared/services/signalr-connection.service';
@Component({
    selector: 'body',
    templateUrl: './app.component.html',
    providers: [MessageService]
})

export class AppComponent implements OnInit, AfterViewInit {
    isFormChangesDetected: boolean;
    loggedInUserData: LoggedInUserModel;
    agentExtensionNo;
    setInterval;
    customerContactDetail;
    rebookNotiList: any = [];
    rebookNotiIndex: number = 0;
    onHoldNotiList: any = [];
    onHoldNotiIndex: number = 0;
    onNoSignalNotiList: any = [];
    onNoSignalNotiIndex: number = 0;
    sound: any;
    msgs: any = [];
    broadcastChannel: BroadcastChannel;
    agentEncryptedPassword = "";
    openedPrimeDialog: any = [];
    private telephonyHubEventHandlersAttached = false;

    constructor(private router: Router, private activatedRoute: ActivatedRoute, private titleService: Title,
        private store: Store<AppState>, private otherService: OtherService, private rxjsService: RxjsService, private snackbarService: SnackbarService,
        private appDataService: AppDataService, private userService: UserService, private signalrConnectionService: SignalrConnectionService,
        private crudService: CrudService, private dialog: MatDialog, private readonly agentLoginService: AgentLoginService,
        private messageService: MessageService, private renderer: Renderer2) {
        this.store.pipe(select(agentLoginDataSelector)).subscribe((extension: string) => {
            this.agentExtensionNo = extension;
            if (this.agentExtensionNo) {
                // inbound and outbound call signalR hug config initiation
                this.hubConnectionForTelephonyAPIConfigs();
            }
        });
    }

    ngAfterViewInit(): void {
        let loader = this.renderer.selectRootElement('#loader');
        this.renderer.setStyle(loader, 'display', 'none');
    }

    // Broadcast event to all the listeners ( multiple tabs ). If any change in the local storage it will trigger this listener in all the opened tabs
    // The below listener will start to listen the changes in localstorage only when more than one tab is opened
    @HostListener('window:storage', ['$event'])
    onLocalStorageValueChanges(event) {
        if ((localStorage?.hasOwnProperty('encodedJWTToken') && localStorage.encodedJWTToken) ||
            (!localStorage && !this.userService.encodedJWTToken) ||
            (localStorage?.length == 0)) {
            if (!this.userService.encodedJWTToken) {
                if (this.otherService?.previousUrl?.includes('non-crm') ||
                    window.location.href.includes('generate-password')) {
                    return;
                };
                if (this.loggedInUserData?.userId) {
                    this.removeAllApplicationData();
                }
            }
        }
    }

    // @HostListener('window:beforeunload', ['$event'])
    // beforeUnload(event) {
    //     if (this.isFormChangesDetected) {
    //         return false;
    //     }
    // }

    ngOnInit(): void {
        this.store.select(agentEncryptedPassword$).subscribe((agentEncryptedPassword) => {
            this.agentEncryptedPassword = agentEncryptedPassword;
        });
        this.rxjsService.getCustomerContactNumber().subscribe((customerContactDetail) => {
            if (!customerContactDetail) {
                return;
            }
            this.customerContactDetail = customerContactDetail;
        });
        this.sound = document.getElementById("audio");
        combineLatest([
            this.store.select(loggedInUserData),
            this.rxjsService.getFormChangeDetectionProperty()
        ]).subscribe((response) => {
            this.loggedInUserData = new LoggedInUserModel(response[0]);
            this.isFormChangesDetected = response[1];
        });
        this.store.pipe(select(isLoggedIn)).subscribe((isLoggedIn: boolean) => {
            if (isLoggedIn == false) {
                clearInterval(this.setInterval);
            }
        });
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map((event: NavigationEnd) => {
                // prevent the user to go to login page and navigates to common dashboard whenever already logged in in another tab
                if (event.url == '/login' && this.loggedInUserData?.userId) {
                    if (!this.otherService?.previousUrl?.includes('generate-password')) {
                        let navigateableUrl = (this.otherService.previousUrl == '/login') ? DEFAULT_COMMON_DASHBOARD_NAVIGATION :
                            this.otherService.previousUrl ? this.otherService.previousUrl : DEFAULT_COMMON_DASHBOARD_NAVIGATION;
                        this.router.navigateByUrl(navigateableUrl);
                    }
                }
                let child = this.activatedRoute.firstChild;
                while (child) {
                    if (child.firstChild) {
                        child = child.firstChild;
                    } else if (child.snapshot.data && child.snapshot.data['title']) {
                        return child.snapshot.data['title'];
                    } else {
                        return null;
                    }
                }
                return null;
            })).subscribe((data: any) => {
                // make sure to change form detection property to false on every route change
                this.rxjsService.setFormChangeDetectionProperty(false);
                this.rxjsService.setFormSubmittedSuccessfullyProperty(false);

                // Check if there's a custom title set by components
                const customTitle = this.otherService.customTitle;
                if (customTitle) {
                    // Use the custom title instead of route data
                    this.otherService.title = customTitle + ' - Fidelity';
                    this.titleService.setTitle(this.otherService.title);
                } else if (data && this.otherService.title != data) {
                    // Use route data title only if no custom title is set
                    this.otherService.title = data + ' - Fidelity';
                    this.titleService.setTitle(this.otherService.title);
                }
            });
        this.onLoadRoute();
        this.router.events.pipe(filter((routerEvent: any) => routerEvent instanceof RoutesRecognized), pairwise())
            .subscribe((routerEvents: RoutesRecognized[]) => {
                this.otherService.previousUrl = routerEvents[0].urlAfterRedirects;
                this.otherService.currentUrl = routerEvents[1].urlAfterRedirects;
            });
        this.rxjsService.setFromUrl(this.appDataService.fromUrlOfLeadLifecycle)
        if (this.loggedInUserData.userId) {
            this.getUpdatedSalesNotifications(this.loggedInUserData.userId);
            this.onLoadHubConnection();
        }
        //For Login time call subject called
        this.rxjsService.getLoginSuccess().subscribe((res) => {
            if (res) {
                this.onLoadHubConnection();
            }
        })
        /* If the agent is already logged In the same system and the same user ID ( event with different browsers ) then call the api to fetch the 
agent details rather than logging in again */
        if (this.loggedInUserData.userId && this.agentLoginService.isOpenScapeProvider) {
            retrieveAlreadyLoggedInAgentDetails(this.crudService, this.userService, this.loggedInUserData, this.agentEncryptedPassword, this.store);
        }
        // Helps to share the userId across the angular opened tabs
        this.broadcastChannel = new BroadcastChannel("Refresh Token Sharing Between Tabs");
        this.broadcastChannel.onmessage = (e) => {
            if (e?.data?.userId) {
                if (this.otherService?.previousUrl) {
                    this.userService.onAppLogout(e.data.userId);
                }
            }
        }
    }

    onLoadRoute() {
        this.activatedRoute.url.subscribe((res) => {
            this.otherService.previousUrl = window.location.pathname;
            this.otherService.currentUrl = window.location.pathname;
        });
    }

    hubConnectionInstanceForSalesAPI: HubConnection;
    hubConnectionForSalesAPIConfigs(loggedInUserId?: string) {
        let signalrConnectionService = this.signalrConnectionService.hubConnectionInitializationForSalesAPIPromise();
        signalrConnectionService.then(() => {
            this.hubConnectionInstanceForSalesAPI = this.signalrConnectionService.salesAPIHubConnectionBuiltInstance();
            this.hubConnectionInstanceForSalesAPI.on(SignalRTriggers.ScheduleCallbackTrigger, data => {
                if (this.loggedInUserData.userId.toLowerCase() == data.createdUserId.toLowerCase()) {
                    data.triggerName = SignalRTriggers.ScheduleCallbackTrigger;
                    data.fromModule = 'Lead';
                    data.type = "Schedule Callback";
                    this.rxjsService.setDialogOpenProperty(true);
                    this.dialog.open(ScheduleCallbackViewModalComponent, { disableClose: true, data, width: '750px' });
                }
            });
            this.hubConnectionInstanceForSalesAPI.on(SignalRTriggers.CustomerAgentCallbackTrigger, data => {
                console.log('CustomerAgentCallbackTrigger:', data);
                if (this.loggedInUserData.userId.toLowerCase() == data.assignedToUserId.toLowerCase()) {
                    data.triggerName = SignalRTriggers.CustomerAgentCallbackTrigger;
                    data.fromModule = 'Customer';
                    data.type = "Schedule Callback";
                    this.rxjsService.setDialogOpenProperty(true);
                    this.dialog.open(ScheduleCallbackViewModalComponent, { disableClose: true, data, width: '750px' });
                }
            });
            //receive new messages
            this.hubConnectionInstanceForSalesAPI.on('newMessage', (receivedMessage) => {
                this.sound.play();
                this.messageService.add({ severity: 'info', summary: receivedMessage.NewMessage.Sender, detail: receivedMessage.NewMessage.Text });
                setTimeout(() => {
                    this.msgs = [];
                }, 10000);
            });
            // to accept the queue based incoming calls
            this.hubConnectionInstanceForSalesAPI.on(SignalRTriggers.CallbackAcceptNotificationTrigger, data => {
                console.log('CallbackAcceptNotificationTrigger:', data);
                if (this.loggedInUserData.userId.toLowerCase() == data.createdUserId.toLowerCase() && data.extensionNumber == this.agentExtensionNo) {
                    if (data.customerId) {
                        data.triggerName = SignalRTriggers.CallbackAcceptNotificationTrigger;
                        data.fromModuleForSubmit = 'Openscape';
                        data.type = "Schedule Callback";
                        this.rxjsService.setDialogOpenProperty(true);
                        this.rxjsService.setscheduleCallbackDetails(data);
                    }
                }
            });
            this.hubConnectionInstanceForSalesAPI.on(SignalRTriggers.DynamicDataChangeTrigger, data => {
                if (data) {
                    this.getDynamicAppData();
                }
            });
            // notifications signalR trigger
            this.hubConnectionInstanceForSalesAPI.on(SignalRTriggers.NotificationTrigger, ({ UserId }) => {
                if (UserId == loggedInUserId) {
                    this.getUpdatedSalesNotifications(loggedInUserId);
                }
            });
            this.hubConnectionInstanceForSalesAPI.on(SignalRTriggers.RebookSnoozeTrigger, data => {
                let exist = data.filter(x => x.UserId == this.loggedInUserData.userId);
                if (exist?.length) {
                    let rebookDialogAlreadyExist = [];
                    exist?.filter(x => {
                        this.dialog.openDialogs?.forEach((el: any) => {
                            if (x.UserId == this.loggedInUserData.userId && x.CallInitiationRebookId == el?.componentInstance?.popupData?.CallInitiationRebookId) {
                                rebookDialogAlreadyExist.push(x.CallInitiationRebookId);
                            }
                        });
                    });
                    if (rebookDialogAlreadyExist?.length) {
                        return;
                    }
                    this.rebookNotiList = exist;
                    this.rxjsService.setDialogOpenProperty(true);
                    this.openRebookNotificationDialog(this.rebookNotiList[0]);
                }
            });
            // user idle logout trigger
            this.hubConnectionInstanceForSalesAPI.on(SignalRTriggers.LogoutNotificationTrigger, data => {
                console.log("LogoutNotificationTrigger data:", data);
                if (data?.UserId === this.loggedInUserData?.userId) {
                    console.log("LogoutNotificationTrigger is called and logged in user details are:", this.loggedInUserData);
                    this.snackbarService.openSnackbar(data.Message, ResponseMessageTypes.SUCCESS);
                    if (this.loggedInUserData.adReferenceId) {
                        this.userService.onLogout();
                    }
                    else {
                        this.removeAllApplicationData('trigger');
                    }
                }
            });


            // Agent login trigger
            this.hubConnectionInstanceForSalesAPI.on(SignalRTriggers.AgentLoggedinTrigger, data => {
                console.log("Agent login Trigger data:", data);

            });

            this.hubConnectionInstanceForSalesAPI.on(SignalRTriggers.CallInitiationOnholdFollowupTrigger, arrayData => {
                console.log('CallInitiationOnholdFollowupTrigger:', arrayData);
                let exist = arrayData.filter(x => x.CreatedUserId?.toLowerCase() == this.loggedInUserData.userId?.toLowerCase());
                if (exist?.length) {
                    let onHoldDialogAlreadyExist = [];
                    exist?.filter(x => {
                        this.dialog.openDialogs?.forEach((el: any) => {
                            if (x.CreatedUserId == this.loggedInUserData?.userId && x?.CallInitiationOnholdRequestId == el?.componentInstance?.data?.CallInitiationOnholdRequestId) {
                                onHoldDialogAlreadyExist.push(x.CallInitiationOnholdRequestId);
                            }
                        })
                    });
                    if (onHoldDialogAlreadyExist?.length) {
                        return;
                    }
                    this.onHoldNotiList = exist;
                    this.rxjsService.setDialogOpenProperty(true);
                    this.openOnHoldFollowupDialog(this.onHoldNotiList[0]);
                }
            });
            this.hubConnectionInstanceForSalesAPI.on(SignalRTriggers.NoSignalFollowUpTrigger, arrayData => {
                console.log('NoSignalFollowUpTrigger:', arrayData);
                let exist = arrayData.filter(x => x.UserId?.toLowerCase() == this.loggedInUserData.userId?.toLowerCase());
                if (exist?.length) {// && !this.dialog.openDialogs?.length for only one dialog for all the signalr trigger
                    let onNoSignalDialogAlreadyExist = [];
                    exist?.filter(x => {
                        this.dialog.openDialogs?.forEach((el: any) => {
                            if (x.UserId == this.loggedInUserData?.userId && x?.NoSignalRequestId == el?.componentInstance?.data?.NoSignalRequestId) {
                                onNoSignalDialogAlreadyExist.push(x.NoSignalRequestId);
                            }
                        })
                    });
                    if (onNoSignalDialogAlreadyExist?.length) {
                        return;
                    }
                    this.onNoSignalNotiList = exist;
                    this.rxjsService.setDialogOpenProperty(true);
                    this.openNoSignalFollowupDialog(this.onNoSignalNotiList[0]);
                }
            });
            // technician
            this.hubConnectionInstanceForSalesAPI.on(SignalRTriggers.InspectionCallbackTrigger, data => {
                console.log('InspectionCallbackTrigger:', data);
                if (this.loggedInUserData.userId.toLowerCase() == data.CreatedUserId.toLowerCase()) {
                    data['type'] = 'complete';
                    data['header'] = 'Inspection Call Back';
                    let insCallbackDialogAlreadyExist = [];
                    this.dialog.openDialogs?.forEach((el: any) => {
                        if (this.loggedInUserData?.userId?.toLowerCase() == data?.CreatedUserId?.toLowerCase() && data?.CustomerInspectionCallBackId == el?.componentInstance?.popupData?.CustomerInspectionCallBackId) {
                            insCallbackDialogAlreadyExist.push(data?.CustomerInspectionCallBackId);
                        }
                    })
                    if (insCallbackDialogAlreadyExist?.length) {
                        return;
                    }
                    // open 1st pop up
                    this.rxjsService.setDialogOpenProperty(true);
                    this.openInspectionCallbackDialog(data);
                }
            });
            this.hubConnectionInstanceForSalesAPI.on(SignalRTriggers.ThirdPartySubcontractorJobDocumentNotUploadedTrigger, arrayData => {
                console.log('ThirdPartySubcontractorJobDocumentNotUploadedTrigger:', arrayData);
                arrayData?.forEach(data => {
                    if (this.loggedInUserData.userId.toLowerCase() == data?.CreatedUserId?.toLowerCase()) {
                        this.openAlertDialog(data);
                    }
                })
            });

            this.hubConnectionInstanceForSalesAPI.onclose((data) => {
                this.hubConnectionInstanceForSalesAPI = undefined;
            });
        })
            .catch();
    }

    hubConnectionForChatAPIConfigs() {
        this.signalrConnectionService.hubConnectionInitializationForChatAPIPromise();
        this.signalrConnectionService.getChatObserveEvent().subscribe((res: any) => {
            if (res && res?.event == 'newMessage') {
                this.sound.play();
                this.messageService.add({ severity: 'info', summary: res?.result.NewMessage.Sender, detail: res?.result?.NewMessage?.Text });
            }
        });
    }

    openRebookNotificationDialog(exist) {
        const ref = this.dialog.open(RebookSnoozeModalComponent, {
            width: '650px',
            data: exist,
            disableClose: true
        });
        ref.afterClosed().subscribe(() => {
            if (this.rebookNotiIndex < (this.rebookNotiList.length - 1)) {
                this.rebookNotiIndex++;
                this.openRebookNotificationDialog(this.rebookNotiList[this.rebookNotiIndex])
            }
        });
    }

    openOnHoldFollowupDialog(data) {
        const message = data['NotificationText'];
        const dialogData = new ConfirmDialogModel("Onhold Followup", message);
        const reqObj = {
            CallInitiationOnholdRequestId: data?.CallInitiationOnholdRequestId,
            CallInitiationId: data?.CallInitiationId,
            CreatedUserId: data?.CreatedUserId,
        }
        const callOnHoldDialog = this.dialog.open(ConfirmDialogPopupComponent, {
            maxWidth: "450px",
            data: {
                ...dialogData, msgCenter: true, isAlert: true, isClose: true, isAPICall: true, CallInitiationOnholdRequestId: data?.CallInitiationOnholdRequestId,
                api: this.crudService.update(ModulesBasedApiSuffix.TECHNICIAN,
                    TechnicalMgntModuleApiSuffixModels.CALL_INITIATION_ON_HOLD_FOLLOWUP, reqObj)
            },
            disableClose: true,
        });
        callOnHoldDialog.afterClosed().subscribe(dialogResult => {
            if (this.onHoldNotiIndex < this.onHoldNotiList?.length - 1) {
                this.onHoldNotiIndex++;
                this.openOnHoldFollowupDialog(this.onHoldNotiList[this.onHoldNotiIndex])
            }
        });
    }

    openInspectionCallbackDialog(data) {
        const appointmentDialog = this.dialog.open(TechnitianInspectionSnoozeModalComponent, {
            width: '450px',
            data: data,
            disableClose: true,
            autoFocus: false
        });
        appointmentDialog.afterClosed().subscribe(result => {
            if (result) {
                appointmentDialog.close();
                return;
            }
            if (this.userService.loggedInUserData) {
                let dataForSnooze = {
                    CustomerInspectionCallBackId: data['CustomerInspectionCallBackId'],
                    CreatedUserId: data['CreatedUserId'],
                    type: 'snooze',
                    header: 'Snooze'
                };
                // open 2nd pop up
                const appointmentDialogSnooze = this.dialog.open(TechnitianInspectionSnoozeModalComponent, {
                    width: '350px',
                    data: dataForSnooze,
                    disableClose: true,
                    autoFocus: false
                });
                appointmentDialogSnooze.afterClosed().subscribe(result => {
                });
            }
            this.rxjsService.setDialogOpenProperty(false);
        });
    }


    openNoSignalFollowupDialog(data) {
        const message = data['NotificationMessage'];
        const dialogData = new ConfirmDialogModel("Signal Special-No Signals", message);
        const reqObj = {
            NoSignalRequestFollowUpId: data?.NoSignalRequestFollowUpId,
            CreatedUserId: data?.UserId,
        }
        const noSignalDialog = this.dialog.open(ConfirmDialogPopupComponent, {
            maxWidth: "450px",
            data: {
                ...dialogData, msgCenter: true, isAlert: true, isClose: true, isAPICall: true, NoSignalRequestId: data?.NoSignalRequestId,
                api: this.crudService.update(ModulesBasedApiSuffix.TECHNICIAN,
                    TechnicalMgntModuleApiSuffixModels.NO_SIGNAL_FOLLOWUP_ACKNOWLEDGE, reqObj)
            },
            disableClose: true,
        });
        noSignalDialog.afterClosed().subscribe(dialogResult => {
            if (this.onNoSignalNotiIndex < this.onNoSignalNotiList?.length - 1) {
                this.onNoSignalNotiIndex++;
                this.openNoSignalFollowupDialog(this.onNoSignalNotiList[this.onNoSignalNotiIndex])
            }
        });
    }

    openAlertDialog(data) {
        const message = data['NotificationText'];
        const dialogData = new ConfirmDialogModel("Alert", message);
        const callOnHoldDialog = this.dialog.open(ConfirmDialogPopupComponent, {
            maxWidth: "450px",
            data: {
                ...dialogData, msgCenter: true, isAlert: true,
            },
            disableClose: true,
        });
        callOnHoldDialog.afterClosed().subscribe(dialogResult => {
            if (dialogResult) {
            }
        });
    }

    hubConnectionInstanceForTelephonyAPI: HubConnection;
    hubConnectionForTelephonyAPIConfigs() {
        if (!this.agentExtensionNo) {
            return;
        }
        this.signalrConnectionService.hubConnectionInitializationForTelephonyAPIPromise().then(() => {
            const hub = this.signalrConnectionService.telephonyAPIHubConnectionBuiltInstance();
            if (!hub) {
                return;
            }
            const hubChanged = this.hubConnectionInstanceForTelephonyAPI !== hub;
            this.hubConnectionInstanceForTelephonyAPI = hub;
            if (!hubChanged && this.telephonyHubEventHandlersAttached) {
                return;
            }
            this.telephonyHubEventHandlersAttached = true;

            /* Openscape Inbound Events */
            // Inbound call delivered
            this.hubConnectionInstanceForTelephonyAPI.on(SignalRTriggers.InboundCallDeliveredTrigger, data => {
                console.log('InboundCallDeliveredTrigger', data);
                if (this.agentExtensionNo == data.ExtensionNumber) {
                    data.triggerName = SignalRTriggers.InboundCallDeliveredTrigger;
                    this.rxjsService.setInboundCallDetails(data);
                }
            });
            // Inbound call received
            this.hubConnectionInstanceForTelephonyAPI.on(SignalRTriggers.InboundCallNotificationsTrigger, data => {
                console.log('InboundCallNotificationsTrigger', data);
                if (this.agentExtensionNo == data.ExtensionNumber) {
                    data.triggerName = SignalRTriggers.InboundCallNotificationsTrigger;
                    this.rxjsService.setInboundCallDetails(data);
                }
            });
            // Inbound call disconnect
            this.hubConnectionInstanceForTelephonyAPI.on(SignalRTriggers.InboundCallDisconnectedNotificationsTrigger, data => {
                console.log('InboundCallDisconnectedNotificationsTrigger', data);
                if (this.agentExtensionNo == data.ExtensionNumber) {
                    data.triggerName = SignalRTriggers.InboundCallDisconnectedNotificationsTrigger;
                    this.rxjsService.setInboundCallDetails(data);
                }
            });
            // Inbound call failed
            this.hubConnectionInstanceForTelephonyAPI.on(SignalRTriggers.InboundCallFailedNotificationsTrigger, data => {
                console.log('InboundCallFailedNotificationsTrigger', data);
                if (this.agentExtensionNo == data.ExtensionNumber) {
                    data.triggerName = SignalRTriggers.InboundCallFailedNotificationsTrigger;
                    this.rxjsService.setInboundCallDetails(data);
                }
            });
            /* End Of Openscape Inbound Events */

            /* Openscape Outbound Events */
            // Outbound call is created by the customer
            this.hubConnectionInstanceForTelephonyAPI.on(SignalRTriggers.OutboundCallDeliveredTrigger, data => {
                console.log('OutboundCallDeliveredTrigger', data);
                if (this.agentExtensionNo == data.ExtensionNumber) {
                    data.triggerName = SignalRTriggers.OutboundCallDeliveredTrigger;
                    this.rxjsService.setUniqueCallId(data);
                }
            });
            // Outbound call is received by the customer
            this.hubConnectionInstanceForTelephonyAPI.on(SignalRTriggers.OutboundCallNotificationsTrigger, data => {
                console.log('OutboundCallNotificationsTrigger:', data);
                if (this.agentExtensionNo == data.ExtensionNumber) {
                    data.fromContactNumber = this.agentExtensionNo;
                    data.toContactNumber = this.customerContactDetail?.customerContactNumber?.toString().replace(/\s/g, "");
                    data.customerId = this.customerContactDetail?.customerId;
                    data.customerAddressId = this.customerContactDetail?.siteAddressId;
                    data.occurrenceBookId = this.customerContactDetail?.occurrenceBookId;
                    this.onCreateEventModuleCallLogsForOpenscape('connect', data);
                    data.triggerName = SignalRTriggers.OutboundCallNotificationsTrigger;
                    this.rxjsService.setUniqueCallId(data);
                }
            });
            // Outbound call disconnect
            this.hubConnectionInstanceForTelephonyAPI.on(SignalRTriggers.OutboundCallDisconnectedNotificationsTrigger, data => {
                console.log('OutboundCallDisconnectedNotificationsTrigger:', data);
                if (this.agentExtensionNo == data.ExtensionNumber) {
                    this.rxjsService.getUniqueCallId().subscribe((openscapeConfigDetail) => {
                        if (!openscapeConfigDetail) {
                            return;
                        } else {
                            data['occurrenceBookId'] = openscapeConfigDetail?.occurrenceBookId
                        }
                    })
                    this.onCreateEventModuleCallLogsForOpenscape('disconnect', data);
                    data.triggerName = SignalRTriggers.OutboundCallDisconnectedNotificationsTrigger;
                    this.rxjsService.setUniqueCallId(data);
                }
            });
            // Outbound call failed
            this.hubConnectionInstanceForTelephonyAPI.on(SignalRTriggers.OutboundCallFailedNotificationsTrigger, data => {
                console.log('OutboundCallFailedNotificationsTrigger:', data);
                if (this.agentExtensionNo == data.ExtensionNumber) {
                    this.rxjsService.getUniqueCallId().subscribe((openscapeConfigDetail) => {
                        if (!openscapeConfigDetail) {
                            return;
                        } else {
                            data['occurrenceBookId'] = openscapeConfigDetail?.occurrenceBookId
                        }
                    })
                    this.onCreateEventModuleCallLogsForOpenscape('fail', data);
                    data.triggerName = SignalRTriggers.OutboundCallFailedNotificationsTrigger;
                    this.rxjsService.setUniqueCallId(data);
                }
            });
            /* End Of Openscape Outbound Events */

            /* Openscape Common (Inbound/Outbound) Events */
            // Call hold for both inbound and outbound
            this.hubConnectionInstanceForTelephonyAPI.on(SignalRTriggers.CallHoldNotificationsTrigger, data => {
                console.log('CallHoldNotificationsTrigger:', data);
                if (this.agentExtensionNo == data.ExtensionNumber) {
                    data.triggerName = SignalRTriggers.CallHoldNotificationsTrigger;
                    this.rxjsService.setUniqueCallId(data);
                }
            });
            // Call transfer for both inbound and outbound
            this.hubConnectionInstanceForTelephonyAPI.on(SignalRTriggers.CallTransferredNotificationsTrigger, data => {
                console.log('CallTransferredNotificationsTrigger:', data);
                if (this.agentExtensionNo == data.ExtensionNumber) {
                    data.triggerName = SignalRTriggers.CallTransferredNotificationsTrigger;
                    this.rxjsService.setUniqueCallId(data);
                }
            });
            // /* End Of Openscape Common (Inbound/Outbound) Events */
            this.hubConnectionInstanceForTelephonyAPI.onclose(() => {
                this.hubConnectionInstanceForTelephonyAPI = undefined;
                this.telephonyHubEventHandlersAttached = false;
                if (this.agentExtensionNo && this.loggedInUserData?.userId) {
                    setTimeout(() => this.hubConnectionForTelephonyAPIConfigs(), 2500);
                }
            });
        });
    }

    onCreateEventModuleCallLogsForOpenscape(type: string, payload) {

        let crudService: Observable<IApplicationResponse> = type == 'connect' ? this.crudService.create(ModulesBasedApiSuffix.EVENT_MANAGEMENT, EventMgntModuleApiSuffixModels.OUTBOUND_CALL_CONNECTED_LOG, payload) :
            type == 'disconnect' ? this.crudService.update(ModulesBasedApiSuffix.EVENT_MANAGEMENT, EventMgntModuleApiSuffixModels.OUTBOUND_CALL_DISCONNECTED_LOG, payload) :
                this.crudService.update(ModulesBasedApiSuffix.EVENT_MANAGEMENT, EventMgntModuleApiSuffixModels.OUTBOUND_CALL_FAILED_LOG, payload);
        crudService.subscribe(() => {
            this.rxjsService.setGlobalLoaderProperty(false);
        });
    }

    removeAllApplicationData(type = 'default') {
        this.router.navigateByUrl('login');
        this.store.dispatch(new Logout());
        this.store.dispatch(new SidebarDataRemoved());
        this.store.dispatch(new AgentLogoutDataRemoved());
        this.store.dispatch(new StaticEagerLoadingRemove());
        this.store.dispatch(new DynamicEagerLoadingRemove());
        this.store.dispatch(new LeadCreationUserDataRemoveAction());
        this.store.dispatch(new LeadCreationStepperParamsRemoveAction());
        this.store.dispatch(new LeadHeaderDataRemoveAction());
        this.store.dispatch(new PageBasedPermissionsRemoved());
        this.rxjsService.setUniqueCallId(null);
        this.rxjsService.setCustomerContactNumber(null);
        this.rxjsService.setscheduleCallbackDetails(null);
        this.rxjsService.setAnyPropertyValue(null);
        this.signalrConnectionService.closeAllHubConnections();
        this.hubConnectionInstanceForTelephonyAPI = undefined;
        this.telephonyHubEventHandlersAttached = false;
        localStorage.clear();
        sessionStorage.clear();
        // close all opened angular material popups thoughout the entire application
        this.dialog.closeAll();
        this.closeAllDynamicDialogs();
        if (type !== 'trigger') {
            this.userService.onLogout();
        }
    }

    closeAllDynamicDialogs() {
        console.log('close all prime dialog');
        this.openedPrimeDialog?.forEach(el => {
            if (el) {
                el?.close();
            }
        });
    }

    getUpdatedSalesNotifications(loggedInUserId: string) {
        this.crudService.get(ModulesBasedApiSuffix.COMMON_API, SharedModuleApiSuffixModels.NOTIFICATIONS, loggedInUserId)
            .subscribe((response: IApplicationResponse) => {
                if (response.isSuccess && response.statusCode == 200 && response.resources) {
                    this.rxjsService.setNotifications({ notifications: response.resources.notifications, count: response.resources.notificationCount });
                }
                this.rxjsService.setGlobalLoaderProperty(false);
            });
    }

    onLoadHubConnection() {
        this.hubConnectionForSalesAPIConfigs(this.loggedInUserData.userId);
        this.hubConnectionForChatAPIConfigs();
        if (this.agentExtensionNo) {
            this.hubConnectionForTelephonyAPIConfigs();
        }
    }

    getDynamicAppData() {
        this.crudService.dropdown(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.SALES_API_UX_DYNAMIC, undefined)
            .subscribe((response: IApplicationResponse) => {
                if (response.isSuccess && response.statusCode == 200 && response.resources) {
                    this.store.dispatch(new DynamicEagerLoadingCreate({ dynamicEagerLoadingData: response.resources }));
                }
                this.rxjsService.setGlobalLoaderProperty(false);
            });
    }

    ngOnDestroy() {
        this.msgs = [];
        this.messageService.clear();
    }

    gotoTop(): void {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }
}